import React, { Component } from 'react';
import './styles.css';
import StepperItem from '../StepperItem';
import StepperBar from '../StepperBar';
import StepperLayout from '../StepperLayout';
import range from 'lodash/range';

class Stepper extends Component {
	render() {
		const { game } = this.props;
		return (
			<div className="stepper">
				<StepperLayout>
					<StepperLayout.Body>
						<StepperBar
							submissions={game.businessPlans.length}
							submissionActive={game.lastSubmission}
						/>
						{range(1, 4).map(n => (
							<StepperItem
								key={n}
								submission={n}
								businessPlanID={game.businessPlans[n - 1].submission}
								active={game.lastSubmission >= n}
								missing={game.lastSubmission < n && game.state === 'COMPLETED'}
								game={game}
							/>
						))}
					</StepperLayout.Body>
				</StepperLayout>
			</div>
		);
	}
}

export default Stepper;
